import { Link } from "react-router-dom";
import { NAV, COMPANY } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ink text-paper">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 gap-12 border-b border-inkline py-16 md:grid-cols-12 md:py-20">
          <div className="md:col-span-7">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-invtext">
              {COMPANY.category}
            </p>
            <h2 className="mt-6 max-w-xl font-display text-3xl font-medium leading-[1.1] tracking-tight sm:text-4xl">
              Disciplined pipeline development for commercial insurance agencies.
            </h2>
          </div>

          <div className="md:col-span-4 md:col-start-9">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-invtext">Navigate</p>
            <ul className="mt-6 grid grid-cols-2 gap-3">
              {NAV.filter((n) => n.to !== "/careers" && n.to !== "/contact").map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-invtext transition-colors hover:text-paper">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-4 py-8 md:flex-row md:items-center md:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-invtext">
            &copy; {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-invtext">
            Systems over personalities.
          </p>
        </div>
      </div>
    </footer>
  );
}
